import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import EnrollmentPage from "./pages/EnrollmentPage";
import CSDGPMLandingPage from "./pages/CSDGPMLandingPage";
import CourseCSDGPM from "./pages/CourseCSDGPM";
import WorkshopPhotoEditing from "./pages/WorkshopPhotoEditing";
import WorkshopVideoEditing from "./pages/WorkshopVideoEditing";
import WorkshopSocialMedia from "./pages/WorkshopSocialMedia";
import WorkshopLinkedIn from "./pages/WorkshopLinkedIn";
import WorkshopPromptEngineering from "./pages/WorkshopPromptEngineering";
import WorkshopCanvaDesign from "./pages/WorkshopCanvaDesign";
import WorkshopFreelancing from "./pages/WorkshopFreelancing";
import WorkshopDigitalAds from "./pages/WorkshopDigitalAds";
import WorkshopContentCreation from "./pages/WorkshopContentCreation";
import WorkshopResumePortfolio from "./pages/WorkshopResumePortfolio";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailed from "./pages/PaymentFailed";
import PerformanceMarketingPage from "./pages/PerformanceMarketingPage";
import AIBootcampPage from "./pages/AIBootcampPage";
import ThankYouPage from "./pages/ThankYouPage";
import FilmMakingCoursePage from "./pages/FilmMakingCoursePage";
import GameDevelopmentCoursePage from "./pages/GameDevelopmentCoursePage";
import JewelleryDesignCoursePage from "./pages/JewelleryDesignCoursePage";
import BlenderCharacterCoursePage from "./pages/BlenderCharacterCoursePage";
import BookDemoPage from "./pages/BookDemoPage";
import NoidaExperiencePage from "./pages/NoidaExperiencePage";
import Chatbot from "./components/Chatbot";
import ScrollToHash from "./components/ScrollToHash";
import AnnouncementBar from "./components/AnnouncementBar";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <AnnouncementBar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/enrollment" element={<EnrollmentPage />} />
          <Route path="/enroll" element={<EnrollmentPage />} />
          <Route path="/courses/csdgpm" element={<CourseCSDGPM />} />
          <Route path="/courses/csdgpm-special-offer" element={<CSDGPMLandingPage />} />
          <Route path="/csdgpm-offer" element={<CSDGPMLandingPage />} />
          <Route path="/courses/csdgpm-digital-growth-performance-marketing" element={<CourseCSDGPM />} />
          <Route path="/workshops/photo-editing-ai" element={<WorkshopPhotoEditing />} />
          <Route path="/workshops/video-editing-reels" element={<WorkshopVideoEditing />} />
          <Route path="/workshops/social-media-booster" element={<WorkshopSocialMedia />} />
          <Route path="/workshops/linkedin-personal-branding" element={<WorkshopLinkedIn />} />
          <Route path="/workshops/prompt-engineering" element={<WorkshopPromptEngineering />} />
          <Route path="/workshops/canva-design-secrets" element={<WorkshopCanvaDesign />} />
          <Route path="/workshops/freelancing-side-income" element={<WorkshopFreelancing />} />
          <Route path="/workshops/digital-ads-automation" element={<WorkshopDigitalAds />} />
          <Route path="/workshops/content-creation-mastery" element={<WorkshopContentCreation />} />
          <Route path="/workshops/resume-portfolio-builder" element={<WorkshopResumePortfolio />} />
          {/* Payment Routes */}
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          {/* Performance Marketing Course */}
          <Route path="/performance-marketing" element={<PerformanceMarketingPage />} />
          <Route path="/job-guarantee-course" element={<PerformanceMarketingPage />} />
          {/* AI Bootcamp for School Students */}
          <Route path="/ai-bootcamp" element={<AIBootcampPage />} />
          <Route path="/ai-skills-bootcamp" element={<AIBootcampPage />} />
          <Route path="/ai-course-students" element={<AIBootcampPage />} />
          {/* Thank You Page for Conversion Tracking */}
          <Route path="/thank-you" element={<ThankYouPage />} />
          {/* New Course Pages */}
          <Route path="/film-making-animation-course" element={<FilmMakingCoursePage />} />
          <Route path="/game-development-course" element={<GameDevelopmentCoursePage />} />
          <Route path="/jewellery-designing-course" element={<JewelleryDesignCoursePage />} />
          <Route path="/complete-blender-character-design-course" element={<BlenderCharacterCoursePage />} />
          {/* Unified Book a Demo page */}
          <Route path="/book-demo" element={<BookDemoPage />} />
          {/* Noida Experience Centre microsite */}
          <Route path="/noida" element={<NoidaExperiencePage />} />
        </Routes>
        {/* Global Chatbot & WhatsApp - Available on all pages */}
        <Chatbot />
      </BrowserRouter>
    </div>
  );
}

export default App;